import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Tabs,
  Tab,
  Chip,
  Checkbox,
  Collapse,
  Tooltip,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import React, { useState } from "react";
import SwitchToggle from "../../components/SwitchToggle";
import AddCategory from "../../Modals/addcategory";
import AddSubCategory from "../../Modals/addsubcategory";
import CategoryIcon from "@mui/icons-material/Category";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import CallSplitIcon from "@mui/icons-material/CallSplit";
import StarIcon from "@mui/icons-material/Star";
import BlockIcon from "@mui/icons-material/Block";
import SelectAttribute from "../../Modals/selectattribute";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import LaptopIcon from "@mui/icons-material/Laptop";
import ComputerIcon from "@mui/icons-material/Computer";
import HomeIcon from "@mui/icons-material/Home";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./ManageCategories.scss";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCategories = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [openSubModal, setOpenSubModal] = useState(false);
  const [openAttributeModal, setOpenAttributeModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<number>(1);
  const [expandedSubCategory, setExpandedSubCategory] = useState<number | null>(null);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const handleCloseModal = () => setOpenModal(false);
  const handleCloseSubModal = () => setOpenSubModal(false);
  const handleCloseAttributeModal = () => setOpenAttributeModal(false);

  const [valueTabs1, setValueTabs1] = useState(0);
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };

  // Categories data
  const categories = [
    { id: 1, name: "Mobile Phones", icon: <SmartphoneIcon />, subCategoriesCount: 8 },
    { id: 2, name: "Laptops", icon: <LaptopIcon />, subCategoriesCount: 6 },
    { id: 3, name: "Computers", icon: <ComputerIcon />, subCategoriesCount: 5 },
    { id: 4, name: "Home & Kitchen", icon: <HomeIcon />, subCategoriesCount: 12 },
    { id: 5, name: "Clothing", icon: <CheckroomIcon />, subCategoriesCount: 10 },
  ];

  // Subcategories data (filtered by selected category)
  const allSubCategories = [
    // Mobile Phones subcategories
    { id: 1, categoryId: 1, name: "Mobile Phones", usage: "170 units", createdDate: "01 Sept 2025", isActive: true, isFeatured: true },
    { id: 2, categoryId: 1, name: "Laptops", usage: "78 units", createdDate: "02 Sept 2025", isActive: true, isFeatured: false },
    { id: 3, categoryId: 1, name: "Computers", usage: "56 units", createdDate: "03 Sept 2025", isActive: false, isFeatured: false },
    { id: 4, categoryId: 1, name: "Home & Kitchen", usage: "132 units", createdDate: "04 Sept 2025", isActive: true, isFeatured: true },

    // Laptops subcategories
    { id: 5, categoryId: 2, name: "Gaming Laptops", usage: "45 units", createdDate: "05 Sept 2025", isActive: true, isFeatured: true },
    { id: 6, categoryId: 2, name: "Business Laptops", usage: "32 units", createdDate: "06 Sept 2025", isActive: true, isFeatured: false },

    // Computers subcategories
    { id: 7, categoryId: 3, name: "Desktop PCs", usage: "28 units", createdDate: "07 Sept 2025", isActive: true, isFeatured: false },
    { id: 8, categoryId: 3, name: "All-in-One", usage: "19 units", createdDate: "08 Sept 2025", isActive: true, isFeatured: true },
  ];

  // Attributes data
  const attributes = [
    { id: 1, name: "Color", type: "dropdown", isMandatory: true, isVariant: true, isFilterable: true, isSearchable: true, values: ["Red", "Blue", "Green", "Black", "White"] },
    { id: 2, name: "Size", type: "dropdown", isMandatory: true, isVariant: true, isFilterable: true, isSearchable: false, values: ["Small", "Medium", "Large", "XL"] },
    { id: 3, name: "Storage", type: "dropdown", isMandatory: false, isVariant: true, isFilterable: true, isSearchable: true, values: ["64GB", "128GB", "256GB", "512GB", "1TB"] },
    { id: 4, name: "RAM", type: "dropdown", isMandatory: false, isVariant: false, isFilterable: true, isSearchable: false, values: ["4GB", "8GB", "16GB", "32GB"] },
  ];

  const filteredSubCategories = allSubCategories.filter(
    (sub) => sub.categoryId === selectedCategory
  );

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelectedRows(filteredSubCategories.map((sub) => sub.id));
    } else {
      setSelectedRows([]);
    }
  };
  const isServiceTab = valueTabs1 === 1;

  const handleSelectRow = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  return (
    <>
      <div className="main_title">
        <h1>Manage Categories</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Categories
        </p>
      </div>

      <div className="stats_boxes gap_m">
        {/* TOTAL CATEGORIES */}
        <a href="/manage-categories" className="cards">
          <div className="data_top">
            <h2>
              12
              <p>Total Categories</p>
            </h2>
            <figure className="blue">
              <CategoryIcon fontSize="large" />
            </figure>
          </div>
          <div className="ai_insight info">
            <span>All categories</span>
            <small>including sub-categories</small>
          </div>
        </a>

        {/* SUB CATEGORIES */}
        <a href="/manage-categories?type=sub" className="cards">
          <div className="data_top">
            <h2>
              6
              <p>Sub Categories</p>
            </h2>
            <figure className="warning">
              <CallSplitIcon fontSize="large" />
            </figure>
          </div>
          <div className="ai_insight warning">
            <span>Child categories</span>
            <small>under root</small>
          </div>
        </a>

        {/* FEATURED CATEGORIES */}
        <a href="/manage-categories?filter=featured" className="cards">
          <div className="data_top">
            <h2>
              2
              <p>Featured Categories</p>
            </h2>
            <figure className="active_order">
              <StarIcon fontSize="large" />
            </figure>
          </div>
          <div className="ai_insight positive">
            <span>Highlighted</span>
            <small>shown on homepage</small>
          </div>
        </a>

        {/* INACTIVE CATEGORIES */}
        <a href="/manage-categories?filter=inactive" className="cards">
          <div className="data_top">
            <h2>
              3
              <p>Inactive Categories</p>
            </h2>
            <figure className="danger">
              <BlockIcon fontSize="large" />
            </figure>
          </div>
          <div className="ai_insight negative">
            <span>Hidden</span>
            <small>not visible to users</small>
          </div>
        </a>
      </div>

      <Box className="custom_tabs mt_20">
        <Tabs
          value={valueTabs1}
          onChange={handleChangeTabs1}
          className="custom_tabs_links"
        >
          <Tab label="Products" {...a11yProps(0)} />
          <Tab label="Services" {...a11yProps(1)} />
        </Tabs>
      </Box>

      {/* New Layout with Sidebar and Table */}
      <div className="table_flex">
        <div className="lt">

          <div className="category_management_layout">
            {/* Left Sidebar - Categories */}
            <div className="category_sidebar">
              <div className="sidebar_header">
                <h3>Categories</h3>
                <Button className="btn btn_primary br_15" onClick={() => setOpenModal(true)}>
                  <AddIcon fontSize="small" />
                  Add Category
                </Button>
              </div>

              <div className="category_list">
                {categories.map((category) => (
                  <div
                    key={category.id}
                    className={`category_item ${selectedCategory === category.id ? "active" : ""}`}
                    onClick={() => setSelectedCategory(category.id)}
                  >
                    <div className="category_icon">{category.icon}</div>
                    <div className="category_info">
                      <p className="category_name">{category.name}</p>
                      <span className="category_count">{category.subCategoriesCount} sub-categories</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Main Content - Subcategories Table */}
            <div className="category_main_content">
              <div className="content_header">
                <h2>{categories.find((c) => c.id === selectedCategory)?.name}</h2>
                <p>Manage sub-categories and their attributes</p>
              </div>

              <div className="subcategory_table_wrapper">
                <div className="cards" style={{ borderRadius: 0, border: 'none', boxShadow: 'none' }}>
                  <div className="table_header">
                    <div className="left_s">
                      <SearchBar
                        searchTerm={searchTerm}
                        setDebouncedSearchTerm={setSearchTerm}
                        placeholder="Search sub-categories..."
                      />
                    </div>
                    <div className="right_s">
                      <Button
                        className="btn btn_primary"
                        onClick={() => setOpenSubModal(true)}
                      >
                        <AddIcon /> Add Sub-Category
                      </Button>
                    </div>
                  </div>

                  <TableContainer className="table_container">
                    <Table>
                      <TableHead>
                        <TableRow>


                          <TableCell>Sub-Category</TableCell>
                          <TableCell>Usage</TableCell>
                          <TableCell>Created Date</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Featured</TableCell>
                          <TableCell>Actions</TableCell>
                          {!isServiceTab && (
                            <TableCell>Attributes</TableCell>
                          )}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {filteredSubCategories.map((subCategory) => (
                          <React.Fragment key={subCategory.id}>
                            <TableRow hover>

                              <TableCell>{subCategory.name}</TableCell>
                              <TableCell>
                                <Chip
                                  label={subCategory.usage}
                                  size="small"
                                  sx={{
                                    backgroundColor: "#eff6ff",
                                    color: "#2563eb",
                                    fontWeight: 600,
                                  }}
                                />
                              </TableCell>
                              <TableCell>{subCategory.createdDate}</TableCell>
                              <TableCell>
                                <SwitchToggle />
                              </TableCell>
                              <TableCell>
                                <SwitchToggle />
                              </TableCell>
                              <TableCell>
                                <div className="table_actions v2">
                                  <IconButton onClick={() => setOpenSubModal(true)}>
                                    <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                  </IconButton>
                                  <IconButton>
                                    <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                  </IconButton>
                                </div>
                              </TableCell>
                              {!isServiceTab && (
                                <TableCell>
                                  <Button className="btn btn_primary sm" onClick={() =>
                                    setExpandedSubCategory(
                                      expandedSubCategory === subCategory.id ? null : subCategory.id
                                    )
                                  }>
                                    View Attributes
                                  </Button>
                                </TableCell>
                              )}
                            </TableRow>

                            {/* Expanded Attributes Row */}
                            <TableRow>
                              <TableCell colSpan={8} style={{ padding: 0 }}>
                                <Collapse
                                  in={expandedSubCategory === subCategory.id}
                                  timeout="auto"
                                  unmountOnExit
                                >
                                  <div className="attribute_expansion">
                                    <div className="attribute_header">
                                      <h4>
                                        <AccountTreeIcon fontSize="small" />
                                        Attributes for {subCategory.name}
                                      </h4>
                                      <button
                                        className="add_attribute_btn"
                                        onClick={() => setOpenAttributeModal(true)}
                                      >
                                        <AddIcon fontSize="small" />
                                        Add Attribute
                                      </button>
                                    </div>
                                    <div className="attributes_grid">
                                      {attributes.map((attr) => (
                                        <div key={attr.id} className="attribute_card">
                                          <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                                            <p className="attribute_name">{attr.name}</p>
                                            <Chip label={attr.type} size="small" sx={{ fontSize: '10px', height: '18px', textTransform: 'capitalize' }} />
                                          </Box>
                                          <Box display="flex" gap={0.5} mt={0.5} mb={1}>
                                            {attr.isMandatory && <Chip label="Mandatory" size="small" color="error" variant="outlined" sx={{ fontSize: '9px', height: '16px' }} />}
                                            {attr.isVariant && <Chip label="Variant" size="small" color="primary" variant="outlined" sx={{ fontSize: '9px', height: '16px' }} />}
                                          </Box>
                                          <div className="attribute_values">
                                            {attr.values.slice(0, 3).map((value, idx) => (
                                              <span key={idx} className="value_chip">
                                                {value}
                                              </span>
                                            ))}
                                            {attr.values.length > 3 && (
                                              <span className="value_chip">
                                                +{attr.values.length - 3} more
                                              </span>
                                            )}
                                          </div>
                                          <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                                            <Box display="flex" gap={1}>
                                              <Tooltip title={attr.isFilterable ? "Filterable" : "Not Filterable"}>
                                                <CallSplitIcon sx={{ fontSize: 16, color: attr.isFilterable ? '#2563eb' : '#94a3b8' }} />
                                              </Tooltip>
                                              <Tooltip title={attr.isSearchable ? "Searchable" : "Not Searchable"}>
                                                <StarIcon sx={{ fontSize: 16, color: attr.isSearchable ? '#2563eb' : '#94a3b8' }} />
                                              </Tooltip>
                                            </Box>
                                            <div className="attribute_actions">
                                              <IconButton
                                                size="small"
                                                onClick={() => setOpenAttributeModal(true)}
                                              >
                                                <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                              </IconButton>
                                              <IconButton size="small">
                                                <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                              </IconButton>
                                            </div>
                                          </Box>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rt">
          <div className="ai_panel">
            <h4>AI Insights</h4>

            <div className="ai_alert warning">
              <span className="icon">⚠️</span>
              <p>
                <b>7 SKUs</b> need immediate attention
              </p>
            </div>

            <div className="ai_alert danger">
              <span className="icon">⛔</span>
              <p>
                <b>3 SKUs</b> have zero sales in 30 days
              </p>
            </div>

            <small className="ai_update">
              Next updated ETA: <b>May 5, 2024</b>
            </small>

            <div className="ai_sku_list">
              <div className="ai_sku_row">
                <div className="ai_sku_info">
                  <h5>#PRD_002</h5>
                  <p>Likely to go out of stock by May</p>
                </div>
                <button className="ai_action_btn">Actions ▾</button>
              </div>

              <div className="ai_sku_row">
                <div className="ai_sku_info">
                  <h5>#PRD_010</h5>
                  <p>Likely to go out of stock by May</p>
                </div>
                <button className="ai_action_btn">Actions ▾</button>
              </div>
            </div>

            {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
          </div>
        </div>
      </div>

      <SelectAttribute
        open={openAttributeModal}
        onClose={handleCloseAttributeModal}
        setOpen={setOpenAttributeModal}
      />
      <AddSubCategory
        open={openSubModal}
        onClose={handleCloseSubModal}
        setOpen={setOpenSubModal}
      />
      <AddCategory open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} />
    </>
  );
};

export default ManageCategories;
